import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Select as AntdSelect } from 'antd';
import * as styles from './form-controls.css';

const StyledAntdSelect = styled(AntdSelect)`
  font-size: 16px;
  font-weight: 400;
`;

const Required = styled.span`
  color: red;
`;

const handleCustomChange = (name, onChange) => value => onChange({ target: { name, value } });

// eslint-disable-next-line no-undefined
const fieldRequired = value => value ? undefined : 'Required';

// prettier-ignore
const renderField = ({
  items,
  label,
  input,
  labelStyle,
  placeholder,
  onSelectionChange,
  required,
  searchable,
  meta: { touched, error },
}) =>
  <div className={`${styles.formGroup} ${touched && error && styles.error}`}>
    {label &&
      <label htmlFor={input.name} className={labelStyle}>
        {required && <Required>* </Required>}
        {label}
      </label>
    }
    <StyledAntdSelect
      data-test-id={`${input.name}-select`}
      {...input}
      className={null}
      onChange={
        handleCustomChange(input.name, onSelectionChange) || input.onChange
      }
      placeholder={placeholder}
      showSearch={searchable}
      filterOption={(val, option) =>
        option.children?.toLowerCase().indexOf(val?.toLowerCase()) >= 0
      }
    >
      {items?.map(item =>
        <AntdSelect.Option key={item.id} value={item.id}>
          {item.text}
        </AntdSelect.Option>,
      )}
    </StyledAntdSelect>
    <span className={styles.errorMsg}>{error}</span>
  </div>;

const Select = ({
  items,
  name,
  label,
  labelStyle,
  placeholder,
  onSelectionChange,
  required = true,
  searchable = false,
}) =>
  <Field
    className={styles.formControl}
    name={name}
    label={label}
    component={renderField}
    items={items}
    labelStyle={labelStyle}
    placeholder={placeholder}
    onBlur={e => e.preventDefault()}
    onSelectionChange={onSelectionChange}
    required={required}
    validate={required ? [fieldRequired] : []} // TODO: Allow custom field level validate function
    searchable={searchable}
  />;
Select.propTypes = {
  items: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  labelStyle: PropTypes.string,
  placeholder: PropTypes.string,
  onSelectionChange: PropTypes.func,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
};

export default Select;
